import { createContext, useContext } from "react";
let e = createContext(void 0);
function u() {
  return useContext(e);
}
export {
  u as useProvidedId
};
